import React from 'react';

import { useExportSkanScheme } from 'scenes/SkanSchemes/data/mutations';

import Actions from './Actions';

export const SkanSchemesActions = ({ actions, data }) => {
  const [exportSkanScheme] = useExportSkanScheme();

  const handleExport = () => {
    exportSkanScheme({ id: data.applicationId });
  };

  return <Actions actions={actions} onExport={handleExport} />;
};
